export const isIE11 = () => /Trident.*rv:11\.0/.test(navigator.userAgent)
